import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Button from '@mui/material/Button';
import Switch from '@mui/material/Switch';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
// import TextField from "@mui/material/TextField";
import { toast } from "react-toastify";
import "react-daterange-picker/dist/css/react-calendar.css";
import Divider from '@mui/material/Divider';
import "date-fns";
import FormControl from '@mui/material/FormControl';
import spinner  from '../assign-prescriptions/images/spinner.gif';
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import moment from 'moment-timezone';
import { withTranslation } from "react-i18next";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';
import { enUS } from '@mui/material/locale';

const localeTheme = createTheme(
  {

  },
  localStorage.getItem('i18nextLng') === 'en' ? enUS : frFR,
);

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  if (array && array.length <= 0) {
    return [];
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}class EnhancedTableHead extends React.Component {
  createSortHandler = (property, field) => event => {
    this.props.onRequestSort(event, property, field);
  };

  render() {
    const {
      order,
      orderBy,
      sortId,
      t
    } = this.props;
    const rows = [
      { id: "name", numeric: false, disablePadding: false, label: t("Announcement.Name") ,padding:'10px', field: 'name' },
      { id: "title", numeric: false, disablePadding: false, label: t("Announcement.Title") ,padding:'10px', field: 'title' },
      { id: "description", numeric: false, disablePadding: false, label: t("Announcement.Description") ,padding:'10px', field: 'description' },
      { id: "is_reload_require", numeric: false, disablePadding: false, label: t("Announcement.ReloadRequired") ,padding:'10px', field: 'is_reload_require' },
      { id: "date", numeric: false, disablePadding: false, label: t("Announcement.Date"), padding:'10px', field: 'created_on' },
    ];

    return (
      <TableHead sx={{ height: '56px' }}>
        <TableRow>
          {rows.map(row => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? "none" : "default"}
                sortDirection={orderBy === row.id ? order : false}
                style={{padding:row.padding}}
                sx={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '0.75rem', fontWeight: 500 }}
              >
                <Tooltip
                  title={t("Global.Label.Filter.Sort")}
                  placement={row.numeric ? "bottom-end" : "bottom-start"}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === row.field && sortId === row.id}
                    direction={order}
                    onClick={this.createSortHandler(row.id, row.field)}
                  >
                    {row.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

const styles = theme => ({
  root: {
    width: "100%",
  },
  table: {
    minWidth: 1020
  },
  tableWrapper: {
    overflowX: "auto"
  },
  padding10px:{
    padding:'10px'
  }
  ,
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 390,
  },
  spinner:{
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage:{
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect:'none'
  },
  button : {
    float: 'right',
    bottom: 'calc(100% - 97%)',
    marginTop: '2%',
    background: '#6cca98',
    color: '#fff',
    '&:hover': {
      background: '#6cca98',
      color: '#fff',
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.38)',
      cursor: 'not-allowed',
      background: '#E4E5E8'
    },
  },
  divider:{
    marginTop:'10px',
    height:'5px',
    borderColor:'rgba(0, 0, 0, 0.12)',
    borderStyle: 'solid',
    borderBottomWidth: '5px'
  }
});

// const ITEM_HEIGHT = 48;
// const ITEM_PADDING_TOP = 8;
// const MenuProps = {
//   PaperProps: {
//     style: {
//       maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//       width: 250,
//     },
//   },
// };

let FilterObj = {
  searchtext:'',
  pageNo: 0,
  pageSize: 10,
  sortOrder: 'desc',
  sortColumn: 'created_on',
  tableName: ''
};

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "desc",
      orderBy: "created_on",
      page: 0,
      rowsPerPage: 10,
      isDataEmpty:true,
      loader: false,
      title: '',
      description: '',
      isReloadRequire: false,
      isButtonDisabled: false,
      userData: [],
      totalRecords: 0,
   };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChangePage = (event, page) => {
    event && event.preventDefault();
    const { userData } = this.state;
    FilterObj.pageNo = page;
    if(userData && userData.length > 0) {
      this.BindReleaseHistory();
    }
  };

  handleChangeRowsPerPage = event => {
    const { userData } = this.state;
    FilterObj.pageNo = 0;
    FilterObj.pageSize = event.target.value;
    if(userData && userData.length > 0) {
      this.BindReleaseHistory();
    }
  };

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem('i18nextLng');
    let zone;
    zone = sessionStorage.getItem('timeZone');
    const date = moment(new Date(requestDate));
    if (['null', null, 'undefined', undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
  }

  BindReleaseHistory = () => {
    this.setState({loader:true});
    fetch(process.env.REACT_APP_BASEURL +  "releasing/history/getAllReleasingHistory", {
        method: 'POST',
        withCredentials: true,
        headers: {
          'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(FilterObj)
      })
      .then(response => response.json())
      .then(response => {
        this.setState({ totalRecords: response && response.total, loader: false });
        if(response && response.results && response.results.length > 0){
          this.setState({ userData: response.results, isDataEmpty: false })
        }else{
          this.setState({ userData: null, isDataEmpty: true });
        }
        }).catch((error) => {
        return error
    })
  }

  checkPermission = () => {
    let permissions = JSON.parse(sessionStorage.getItem('permissions'));
    if(permissions && permissions.length > 0){
      let permissionObj = {};
      permissions
      .filter(val => val.permission_entity_type === 'Manage Announcement')
      .map((item) => {
        return item.permission_entity_type === 'Manage Announcement' &&
            item.name === 'Add'
          ? (permissionObj.add = true)
          : null;
      });
      if (permissionObj.add) {
        this.setState({ announcementAddPermission: true });
      } else this.setState({ announcementAddPermission: false });
    }
  };

  componentDidMount = () => {
     this.BindReleaseHistory();
     this.checkPermission();
  }

    handleChange = (event) => {
      event.preventDefault();
      const value = event && event.target.name;
      switch (value) {
        case 'title':
          this.setState({ title: event.target.value });
          break;
        case 'description':
          this.setState({ description: event.target.value });
          break;
        default:
          break;
      }
    };

    handleChangeReloadRequired = (event) => {
      this.setState({ isReloadRequire: event.target.checked });
    };

    handleSubmit = (event) => {
        this.setState({ loader: true });
        event.preventDefault();
        this.setState({ isButtonDisabled: true });
        let popUpNofifictionObj = {
          title: this.state.title,
          description: this.state.description,
          isReloadRequire: this.state.isReloadRequire,
        };
        fetch(process.env.REACT_APP_BASEURL + 'releasing/history', {
          method: 'POST',
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                .jwtToken,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(popUpNofifictionObj),
        })
          .then((response) => response.json())
          .then((response) => {
            this.setState({ title: '', description: '', isReloadRequire: false, loader: false});
            toast.success(response.message);
            this.componentDidMount()
          })
          .catch((error) => {
            this.setState({ title: '', description: '', isReloadRequire: false, loader: false});
            toast.error(error.message);
          });
    };

    gettingOnSortTableName = (field) => {
      let tablename = '';
      if(['name'].includes(field)){
        tablename = 'users';
      }
      if(['title', 'description', 'is_reload_require', 'date'].includes(field)){
        tablename = 'releasing_history';
      }
      return tablename;
    }

    handleRequestSort = (event, property, field) => {
      const orderBy = property;
      let order = 'desc';
      if (this.state.order === 'desc') {
        order = 'asc';
      }
      this.setState({ order, orderBy, sortId: property });
      FilterObj.sortOrder = order;
      FilterObj.sortColumn = field;
      FilterObj.tableName = this.gettingOnSortTableName(orderBy);
      const { userData } = this.state;
      if(userData && userData.length > 0){
        this.BindReleaseHistory();
      }
    };

  render() {
    const { classes, t } = this.props;
    const { userData, totalRecords, sortId, announcementAddPermission } = this.state;
    return (
      <Paper className={classes.root}>
      {
        this.state.loader ?
        <div className={classes.spinner}>
          <img className={classes.spinnerImage} src={spinner} alt="loading" />
        </div>:
        null
      }
      <div>
      {announcementAddPermission && (
        <ValidatorForm ref="form" onSubmit={this.handleSubmit} >
          <Table className={classes.table} aria-labelledby="tableTitle">
            <TableBody>
                <TableRow>
                    <TableCell style={{width:"30%",borderBottom:"none"}}>
                      <FormControl className={classes.formControl} fullWidth>
                          <TextValidator
                            className={classes.halfTextField}
                            margin='normal'
                            id='title'
                            name='title'
                            value={this.state.title}
                            label={t("Announcement.TitleTextField")}
                            type='title'
                            fullWidth
                            onChange={this.handleChange}
                            validators={["required"]}
                            errorMessages={[t("Announcement.EnterTitle")]}
                            variant="standard"
                          />
                      </FormControl>
                    </TableCell>
                    <TableCell style={{width:"30%",borderBottom:"none"}}>
                      <FormControl className={classes.formControl} fullWidth>
                          <TextValidator
                            className={classes.textField}
                            margin='dense'
                            name='description'
                            value={this.state.description}
                            label={t("Announcement.DescriptionTextField")}
                            fullWidth
                            onChange={this.handleChange}
                            validators={["required"]}
                            errorMessages={[t("Announcement.EnterDescription")]}
                            variant="standard"
                          />
                      </FormControl>
                    </TableCell>
                    <TableCell style={{width:"20%",borderBottom:"none",paddingTop:"41px"}}>
                        <div className={classes.flexItemToggle} style={{ fontSize: '0.8125rem' }}>
                          {t("Announcement.ReloadRequiredToggle")}
                          <Switch
                          checked={this.state.isReloadRequire}
                          onChange={this.handleChangeReloadRequired}
                          value={this.state.isReloadRequire}
                          color='primary'
                          />
                        </div>
                    </TableCell>
                    <TableCell style={{width:"25%",borderBottom:"none",paddingTop:"25px"}}>
                      <Button color='primary' type="submit" className={classes.button} sx={{minWidth: '100px'}}>
                        {t("Announcement.Save")}
                      </Button>
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>
        </ValidatorForm>
      )}
      </div>
      <Divider className={classes.divider}/>

        <div className={classes.tableWrapper}>
         <Table className={classes.table} aria-labelledby="tableTitle">
            <EnhancedTableHead
              order={FilterObj.sortOrder}
              orderBy={FilterObj.sortColumn}
              onRequestSort={this.handleRequestSort}
              sortId={sortId}
            />
            <TableBody>
              {!userData ?
                  (<TableRow>
                       <TableCell colSpan={14} style={{textAlign:"center", padding: '10px 0px'}}>
                       {this.state.isDataEmpty && t("Announcement.NoDataFound") }
                        </TableCell>
                  </TableRow>)
                :
                userData && userData.length > 0 &&
                stableSort(userData, getSorting(FilterObj.sortOrder, FilterObj.sortColumn))
                .map(n => {
                  return (
                    <TableRow>
                      <TableCell className={classes.padding10px}>{n.name}</TableCell>
                      <TableCell className={classes.padding10px}>{n.title}</TableCell>
                      <TableCell className={classes.padding10px}>{n.description}</TableCell>
                      <TableCell className={classes.padding10px}>{n.is_reload_require === true ? t("True") : t("False")}</TableCell>
                      <TableCell className={classes.padding10px}>{n.created_on ? this.convertToTimeZone(n && n.created_on) : ''}</TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </div>
        <ThemeProvider theme={localeTheme}>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={totalRecords || 0}
            rowsPerPage={FilterObj.pageSize}
            page={FilterObj.pageNo}
            backIconButtonProps={{
              "aria-label": "Previous Page"
            }}
            nextIconButtonProps={{
              "aria-label": "Next Page"
            }}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
          />
        </ThemeProvider>
      </Paper>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/releaseHistory/index.js